import React from 'react';
import moment from 'moment';

import CompleteProfileMyScheduleForm from '../forms/CompleteProfileMyScheduleForm';

import ShiftActions from '../actions/ShiftActions';


class CompleteProfileStep2 extends React.Component {

    constructor(props) {
        super(props);
    }


    submit(e) {
        e.preventDefault();

        const data = this.refs.form.getValue();
        const errors = this.refs.form.validate(true).errors;
        if (errors) {
            ShiftActions.mergeErrorsIntoState(errors);
        }
        if (data) {
            this.props.addData(data, true);
        }
    }

    render () {
        return (
            <div className="complete-profile-step-content complete-profile-step3">
                <form onSubmit={this.submit.bind(this)} noValidate>
                    <CompleteProfileMyScheduleForm disableBefore={moment()} initialFormData={{}} errors={{}} ref="form" />

                    <div>
                        <button className="btn btn-small btn-green btn-submit" type="submit">Continue</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default CompleteProfileStep2;



/** WEBPACK FOOTER **
 ** ./app/src/components/CompleteProfileStep3.js
 **/